/* eslint-disable tailwindcss/no-arbitrary-value -- text/secondary token (its theme key is shadowed by the legacy palette, see fe CLAUDE.md), the Figma shadow and the safe-area inset have no theme keys */
import { ReactNode } from 'react';

type StickyFooterCtaBarProps = {
  /** The landmark's accessible name, translated (e.g. "Apply"). */
  label: string;
  /** Copy on the left. Long copy wraps onto further lines and is never truncated. */
  heading: ReactNode;
  /** The Apply CTA on the right, vertically centred against the copy. */
  cta: ReactNode;
};

/**
 * Figma "Secondary CTA Block / Sticky Footer" (Columns 2, Subtext No); the caller pins it and fires
 * the CTA event. An `<aside>` landmark, as on the full page it is portalled outside every other one.
 * The TI provider page's `StickyFooterCta` is the same Figma component on older markup.
 */
export const StickyFooterCtaBar: React.FC<StickyFooterCtaBarProps> = ({
  label,
  heading,
  cta,
}) => (
  <aside
    data-component="sticky-footer-cta-bar"
    aria-label={label}
    className="px-spacing/gap/x pb-[calc(var(--spacing-margin-y)+env(safe-area-inset-bottom))] pt-spacing/margin/y shadow-[0_0_8px_0_#00000040] bg-fill/card"
  >
    <div className="mx-auto flex max-w-general/narrow-content-max-width-1 items-center gap-spacing/gap/x">
      <p className="mhg-alpha-typography-body-2-relaxed m-0 min-w-0 flex-1 break-words text-[--text-secondary]">
        {heading}
      </p>
      <div className="shrink-0">{cta}</div>
    </div>
  </aside>
);
